import React from 'react'
import PropTypes from 'prop-types'

import { Image } from './style'

import { mediaQueriesDefinitions } from '../../styles/media-queries'

const StaticMap = React.memo(({ latitude, longitude, altText }) => (
  <picture>
    <source
      media={mediaQueriesDefinitions.tabletLandscapeUp}
      srcSet={`https://maptiles.finncdn.no/staticmap?lat=${latitude}&lng=${longitude}&zoom=14&size=320x160&maptype=normapxhd&showPin=true`}
    />
    <source
      media={mediaQueriesDefinitions.mobileDown}
      srcSet={`https://maptiles.finncdn.no/staticmap?lat=${latitude}&lng=${longitude}&zoom=14&size=600x400&maptype=normapxhd&showPin=true`}
    />
    <source
      media={mediaQueriesDefinitions.tabletPortrait}
      srcSet={`https://maptiles.finncdn.no/staticmap?lat=${latitude}&lng=${longitude}&zoom=14&size=700x350&maptype=normapxhd&showPin=true`}
    />
    <Image
      src={`https://maptiles.finncdn.no/staticmap?lat=${latitude}&lng=${longitude}&zoom=14&size=700x350&maptype=normapxhd&showPin=true`}
      alt={altText}
    />
  </picture>
))

StaticMap.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  altText: PropTypes.string.isRequired,
}

export default StaticMap
